var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "applicant-avatar-container mr-sm-3 mr-1" }, [
    _c(
      "span",
      { staticClass: "d-sm-block d-none" },
      [
        _c(
          "profile-avatar",
          _vm._b(
            {
              staticClass: "client-avatar",
              attrs: { "avatar-initials": _vm.avatarInitials },
            },
            "profile-avatar",
            _vm.clientDetails,
            false
          )
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "registered-tooltip-wrapper" },
      [
        _c("icon", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.bottom",
              value: _vm.tooltipMessage,
              expression: "tooltipMessage",
              modifiers: { bottom: true },
            },
          ],
          staticClass: "registered-tooltip",
          class: _vm.registrationIconColor,
          attrs: { name: _vm.registrationIcon },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }